import { AnimatedSection } from "@/components/shared/AnimatedSection";
import { SectionLabel } from "@/components/shared/SectionLabel";
import { asset } from "@/lib/assets";
const profilePhoto = asset("Veronica_2.jpg");

/**
 * About section: photo left, bio text right.
 * Photo has a gentle float animation.
 */
export function About() {
  return (
    <section id="about" className="py-12 px-6 bg-[#F7F8FA]">
      <div className="max-w-6xl mx-auto">
        <AnimatedSection>
          <SectionLabel>About</SectionLabel>
        </AnimatedSection>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Text column */}
          <AnimatedSection delay={100}>
            <h2 className="font-[Bricolage_Grotesque] font-[550] tracking-[-0.04em] text-[clamp(1.75rem,3.5vw,2.5rem)] text-[#1A1A1A] mb-6 leading-tight">
              Energizing and motivating.{" "}
              <span className="text-[#888888]">That's what they say.</span>
            </h2>

            <div className="space-y-4 text-[#888888] font-[DM_Sans] leading-relaxed">
              <p>
                My name is Verónica Aguilar. I've been a product designer for 9 years. I started
                in visual design, moved into UI/UX and product design, and lately I've been
                evolving into building with AI. I still love the craft of a good old blank canvas,
                but I'm also excited and curious about where our field is going.
              </p>
              <p>
                I'm currently the Lead Designer at HomeLight, where I've been for 4 years (that
                feels like 6). I've worked across our mobile and web products for real estate
                agents, loan officers, and buyers/sellers.
              </p>
              <p>
                Outside of screens, I spend time doing hand lettering (my biggest passion),
                ceramics, and rug tufting.
              </p>
            </div>
          </AnimatedSection>

          {/* Photo column */}
          <AnimatedSection>
            <div className="relative">
              <div className="float-animation">
                <div className="relative rounded-2xl overflow-hidden aspect-[4/5] bg-[#E8EDFB] max-w-sm">
                  <img
                    src={profilePhoto}
                    alt="Verónica Aguilar at Shibuya crossing"
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      // Fallback if photo not found
                      (e.target as HTMLImageElement).style.display = "none";
                    }}
                  />
                  {/* Illustrated stars overlay */}
                  <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
                    <svg viewBox="0 0 400 500" className="absolute top-0 left-0 w-full h-full opacity-60">
                      <g fill="#C4772A">
                        <path d="M60,40 L63,50 L73,50 L65,56 L68,66 L60,60 L52,66 L55,56 L47,50 L57,50 Z" />
                        <path d="M320,80 L322,88 L330,88 L324,93 L326,101 L320,96 L314,101 L316,93 L310,88 L318,88 Z" opacity="0.7" />
                        <path d="M340,200 L342,206 L348,206 L343,210 L345,216 L340,212 L335,216 L337,210 L332,206 L338,206 Z" opacity="0.5" />
                        <circle cx="80" cy="300" r="4" opacity="0.4" />
                        <circle cx="350" cy="380" r="3" opacity="0.6" />
                        <circle cx="30" cy="420" r="5" opacity="0.3" />
                      </g>
                      <g fill="#1D3FE8" opacity="0.4">
                        <circle cx="360" cy="60" r="6" />
                        <circle cx="20" cy="180" r="4" />
                        <circle cx="380" cy="300" r="3" />
                      </g>
                    </svg>
                  </div>
                  {/* Fallback gradient when no photo */}
                  <div className="absolute inset-0 bg-gradient-to-br from-[#E8EDFB] to-[#1D3FE8]/20 -z-10 flex items-center justify-center">
                    <span className="font-[Bricolage_Grotesque] font-bold text-[#1D3FE8] text-6xl opacity-30">VA</span>
                  </div>
                </div>
              </div>

              {/* Location badge */}
              <div className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-[#E8E2D9] text-sm font-[DM_Sans] text-[#888888]">
                <span>📍</span>
                <span>Guadalajara, MX</span>
              </div>
            </div>
          </AnimatedSection>

        </div>
      </div>
    </section>
  );
}
